require("utility/error_display.scss");

class ErrorDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			errorText: null, errors: null
		};
	}

	setError(error) {
		this.setState({ errorText: error, errors: null });
	}

	setErrors(errors) {
		if (errors.length == 1) {
			this.setError(errors[0]);
		} else {
			this.setState({ errors: errors, errorText: null });
		}
	}

	reset(e) {
		$wr.nope(e)
		this.setState({ errorText: null, errors: null });
	}

	render() {
		var errorContent, errors, closeButton;

		if (this.state.errorText) {
			errorContent = (
				<span>{ this.state.errorText }</span>
			);
			
		} else if (this.state.errors && this.state.errors.length == 1) {
			errorContent = (
				<span>{ this.state.errors[0] }</span>
			);

		} else if (this.state.errors) {
			errors = this.state.errors.map(function(error, i) {
				return <li key={ "error" + i }>{ error }</li>;
			});
			errorContent = (
				<div>
					<ul className="move-in">{ errors }</ul>
				</div>
			);
		}
		
		closeButton = (
			<a className="closeLink btn-link" aria-label="Close" onClick={ this.reset }>
				<span aria-hidden="true">Got it</span>
			</a>
		)

		if (errorContent) {
			return (
				<div className="errorDisplay" role="alert">
					{ errorContent }
					{ closeButton }
				</div>
			)			
		} else {
			return null;
		}
	}
};

ErrorDisplay.propTypes = StrictPropTypes({
	// Makes the error box less intrusive
	errorsLite: PropTypes.bool
});

module.exports = ErrorDisplay;



// WEBPACK FOOTER //
// ./modules/components/utility/ErrorDisplay.js